module.exports = __webpack_public_path__ + "img/icon-lock.21bc94dc.svg";